import { Box, Card, CardContent, CircularProgress } from "@mui/material";
import React from "react";
import { currentLocationFromRequest } from "../components/LocationSelector";
import { getLocationRoles } from "../auth";
import { getGrantedMenuItems } from "../components/Drawer";
import { createUrlString } from "../url";
import { redirect } from "react-router";

export function loader({ request }) {
  const locationId = currentLocationFromRequest(request);
  if (locationId == null) {
    return;
  }

  const currentRoles = getLocationRoles(locationId);
  const redirectPath = getGrantedMenuItems(currentRoles)[0]?.to;
  const url = new URL(request.url);

  return redirect(createUrlString(url.origin, url.search, redirectPath));
}

export default function Homepage() {
  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      </CardContent>
    </Card>
  );
}
